var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container"},[_c('Loader',{attrs:{"isVisible":_vm.isLoading}}),_c('div',{staticClass:"main wrapper main-form-container"},[_c('div',{staticClass:"column column-1"},[_c('SubscriptionPoliciesForm')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }